export const API_KEY = "b714f50764cbd08f8dca5b9585c6ab1f"

export const Search_API = `https://api.themoviedb.org/3/search/movie?&api_key=${API_KEY}&query=`

// export const Image_API = "https://image.tmdb.org/t/p/w1280/" + image_path
